import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import Topbar from './Topbar';
import BottomNav from './BottomNav';

class LayoutPublic extends Component {

    render() {
        return (
            <div>
                <Topbar title='BTL Tax Calculator' />
                <BottomNav />
            </div>
        );
    }

}

export default withRouter(LayoutPublic);



// WEBPACK FOOTER //
// ./src/components/Layout/LayoutPublic.jsx